import { render, staticRenderFns } from "./CollapseCard.vue?vue&type=template&id=7bf1b8c5&scoped=true"
import script from "./CollapseCard.vue?vue&type=script&lang=js"
export * from "./CollapseCard.vue?vue&type=script&lang=js"
import style0 from "./CollapseCard.vue?vue&type=style&index=0&id=7bf1b8c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf1b8c5",
  null
  
)

export default component.exports